import { useMemo } from 'react';

import { AUTH_ROUTES, ROOT_ROUTES, PRESCRIBER_ROUTES, ADMIN_ROUTES } from '@router';
import LocalStorageService from '@services/localStorage';
import { PRESCRIBER, NOT_FOUND } from '@router/paths';
import Prescriber from '@pages/Prescriber';
import { RedirectRoot } from '@pages/RedirectRoot';
import { USER_ROLES, PROFILE_STATUSES } from '@utils/consts';
import { AuthLayout, RootLayout } from '@components/index';

const routeRoles = {
  [USER_ROLES.PRESCRIBER]: PRESCRIBER_ROUTES,
  [USER_ROLES.ADMIN]: ADMIN_ROUTES,
};

export const useRouterPaths = (role, status, isMainLoading) => {
  return useMemo(() => {
    if (isMainLoading) {
      return [];
    }

    // If user was rejected - redirect him to create profile page
    if (role === USER_ROLES.PRESCRIBER && status === PROFILE_STATUSES.REJECTED) {
      LocalStorageService.removeWelcomeLayoutVisibility();
      return [
        {
          component: AuthLayout,
          routes: [...ROOT_ROUTES, ...AUTH_ROUTES],
        },
      ];
    }

    if (role === USER_ROLES.PRESCRIBER && status !== PROFILE_STATUSES.ACTIVE) {
      LocalStorageService.removeWelcomeLayoutVisibility();
      return [
        {
          component: RootLayout,
          routes: [
            ...ROOT_ROUTES,
            {
              name: 'confirmationPending',
              path: PRESCRIBER.ROOT,
              exact: true,
              component: Prescriber.ConfirmationPending,
            },
            {
              path: NOT_FOUND,
              component: () => <RedirectRoot path={PRESCRIBER.ROOT} />,
            },
          ],
        },
      ];
    }

    if (routeRoles[role]) {
      LocalStorageService.removeWelcomeLayoutVisibility();
      return [
        {
          component: RootLayout,
          routes: [...ROOT_ROUTES, ...routeRoles[role]],
        },
      ];
    }

    return [
      {
        component: AuthLayout,
        routes: [...ROOT_ROUTES, ...AUTH_ROUTES],
      },
    ];
  }, [role, isMainLoading, status]);
};
